import React from "react";

import { BettingOfferStatus } from "@api-types/offer/offer-history/BettingOfferStatus";
import EventHistoryStatusIcon from "@features/offer/shared/event/offer-history/EventHistoryStatusIcon";
import { getOfferHistoryStatusClass } from "@features/offer/shared/event/offer-history/utils";
import { EventKeyBettingOffer } from "@gp/models";
import classNames from "classnames";

export default function OfferHistoryButton(props: {
	/** @default true */
	hasMargin?: boolean;
	isPlayerMarket?: boolean;
	isAdditionalOffer?: boolean;
	isLocked?: boolean;
	isOneClickBetActive?: boolean;
	isSelected?: boolean;
	indicator?: -1 | 0 | 1;
	displayTipName?: string | null;
	label?: string | null;
	tip?: EventKeyBettingOffer;
}) {
	if (props?.tip?.status === undefined) {
		return null;
	}
	const hasMargin = props.hasMargin != null ? props.hasMargin : true;

	const tipLabelClasses = classNames("quote quote--margin", {
		"u-type--left": hasMargin,
		offer__player__tip: props.isPlayerMarket,
		"offer--additional__margin": props.isAdditionalOffer,
	});

	const status = props.tip.status;

	return (
		<>
			{props.displayTipName != null ? (
				<div className={tipLabelClasses} title={props.label || ""}>
					{props.label}
				</div>
			) : null}

			<button
				type="button"
				disabled={status === BettingOfferStatus.Lose}
				className={classNames("quote quote--button", getOfferHistoryStatusClass(status))}
			>
				<EventHistoryStatusIcon status={status} />
			</button>
		</>
	);
}
